// @ts-nocheck
const isInfluencer: boolean = ((): boolean => {
  if (import.meta.client) {
    return window.isInfluenceriOS || window.isInfluencerAndroid || window.location.pathname.startsWith('/influenciador') || window.location.pathname.startsWith('/@') || window.location.search.includes('type=influencer')
  }

  return false
})()

let navigationItems = [
  {
    name: 'Dashboards',
    icon: { name: 'ph:house-duotone', class: 'size-6' },
    activePath: '/app/dashboards',
    children: [
      {
        name: 'Home',
        to: '/app/dashboards/home',
        icon: { name: 'ph:house-duotone', class: 'size-4' },
      },
      {
        name: 'Financeiro',
        to: '/app/dashboards/financeiro',
        icon: { name: 'ph:presentation-chart-duotone', class: 'size-4' },
      },
    ],
  },
  {
    name: 'Encontrar',
    icon: { name: 'ph:magnifying-glass-duotone', class: 'size-6' },
    activePath: '/app/encontrar',
    children: [
      {
        name: 'Perfis Relacionados',
        to: '/app/encontrar/instagram/relacionados',
        icon: { name: 'ph:users-duotone', class: 'size-4' },
      },
      {
        name: 'Concorrentes',
        to: '/app/encontrar/instagram/concorrentes',
        icon: { name: 'ph:graph-duotone', class: 'size-4' },
      },
      {
        name: 'Legendas/Hashtags',
        to: '/app/encontrar/instagram/hashtags',
        icon: { name: 'ph:hash-duotone', class: 'size-4' },
      },
      {
        name: 'Palavras na Bio',
        to: '/app/encontrar/instagram/bio',
        icon: { name: 'ph:text-align-center-duotone', class: 'size-4' },
      },
    ],
  },
  {
    name: 'Influenciadores',
    icon: { name: 'ph:crown-duotone', class: 'size-6' },
    activePath: '/app/influenciadores',
    children: [
      {
        name: 'Em abordagem',
        to: '/app/influenciadores/abordagens',
        icon: { name: 'ph:chats-duotone', class: 'size-4' },
      },
      {
        name: 'Minhas Listas',
        to: '/app/influenciadores/listas',
        icon: { name: 'ph:user-list-duotone', class: 'size-4' },
      },
      {
        name: 'Descartados',
        to: '/app/influenciadores/descartados',
        icon: { name: 'ph:minus-circle-duotone', class: 'size-4' },
      },
    ],
  },
  {
    name: 'Campanhas',
    icon: { name: 'ph:megaphone-duotone', class: 'size-6' },
    activePath: '/app/campanhas',
    children: [
      {
        name: 'Criar Campanha',
        to: '/app/campanhas/criar',
        icon: { name: 'ph:rocket-duotone', class: 'size-4' },
      },
      {
        name: 'Minhas Campanhas',
        to: '/app/campanhas',
        icon: { name: 'ph:folder-open-duotone', class: 'size-4' },
      },
    ],
  },
  {
    name: 'Configurações',
    icon: { name: 'ph:gear-duotone', class: 'size-6' },
    activePath: '/app/configuracoes',
    children: [
      {
        name: 'Empresa',
        to: '/app/configuracoes/empresa',
        icon: { name: 'ph:buildings-duotone', class: 'size-4' },
      },
      {
        name: 'Equipe',
        to: '/app/configuracoes/equipe',
        icon: { name: 'ph:users-three-duotone', class: 'size-4' },
      },
      {
        name: 'Assinatura',
        to: '/app/configuracoes/assinatura',
        icon: { name: 'ph:credit-card-duotone', class: 'size-4' },
      },
      {
        name: 'Integrações',
        to: '/app/configuracoes/integracoes',
        icon: { name: 'ph:link-duotone', class: 'size-4' },
      },
      {
        name: 'Perfil',
        to: '/app/configuracoes/perfil',
        icon: { name: 'ph:user-duotone', class: 'size-4' },
      },
      {
        name: 'Afiliado',
        to: '/app/configuracoes/afiliado',
        icon: { name: 'ph:hand-coins-duotone', class: 'size-4' },
      },
    ],
  },
]

let toolbarTools = [
  {
    component: 'ToggleTheme',
  },
  {
    component: 'ToolbarCompanyNotifications',
  },
  {
    component: 'ToolbarCompanyCredits',
  },
  {
    component: 'ToolbarCompanyMenu',
  },
]

let footerLinks = [
  {
    name: 'Feedback, Roadmap e Changelog',
    to: '/app/feedback',
  },
  {
    name: 'Política de Privacidade',
    to: '/politica-de-privacidade',
  },
  {
    name: 'Termos de Serviço',
    to: '/termos-de-servico',
  },
]

let panels = [
  {
    name: 'PanelAddInfluencers',
    position: 'right',
    component: 'PanelAddInfluencers',
  },
  {
    name: 'PanelCreateList',
    position: 'right',
    component: 'PanelCreateList',
  },
  {
    name: 'PanelEditList',
    position: 'right',
    component: 'PanelEditList',
  },
  {
    name: 'PanelDailyGoals',
    position: 'right',
    component: 'PanelDailyGoals',
  },
  {
    name: 'PanelResearchTaggedPosts',
    position: 'right',
    component: 'PanelResearchTaggedPosts',
  },
  {
    name: 'PanelResearchHashtagPosts',
    position: 'right',
    component: 'PanelResearchHashtagPosts',
  },
  {
    name: 'PanelResearchRelatedInfluencers',
    position: 'right',
    component: 'PanelResearchRelatedInfluencers',
  },
  {
    name: 'PanelResearchInfluencersBio',
    position: 'right',
    component: 'PanelResearchInfluencersBio',
  },
  {
    name: 'PanelConfigureWithdrawal',
    position: 'right',
    component: 'PanelConfigureWithdrawal',
  },
  {
    name: 'PanelEditCampaignApproach',
    position: 'right',
    component: 'PanelEditCampaignApproach',
  },
  {
    name: 'PanelGenerateCoupons',
    position: 'right',
    component: 'PanelGenerateCoupons',
  },
  {
    name: 'PanelCompanyFinances',
    position: 'right',
    component: 'PanelCompanyFinances',
  },
]

if (isInfluencer) {
  navigationItems = [
    {
      name: 'Link Viral',
      icon: { name: 'ph:link-duotone', class: 'size-6' },
      activePath: '/influenciador/link-viral',
      to: '/influenciador/link-viral',
    },
    {
      name: 'Gerar MidiaKit',
      icon: { name: 'ph:presentation-chart-duotone', class: 'size-6' },
      activePath: '/influenciador/midia-kit',
      to: '/influenciador/midia-kit',
    },
    {
      name: 'Minhas Parcerias',
      icon: { name: 'ph:handshake-duotone', class: 'size-6' },
      activePath: '/influenciador/parcerias',
      to: '/influenciador/parcerias',
    },
    {
      name: 'Minhas Comissões',
      icon: { name: 'ph:hand-coins-duotone', class: 'size-6' },
      activePath: '/influenciador/comissoes',
      to: '/influenciador/comissoes',
    },
  ]

  toolbarTools = [
    {
      component: 'ToggleTheme',
    },
    {
      component: 'ToolbarInfluencerMenu',
    },
  ]

  footerLinks = [
    {
      name: 'Política de Privacidade',
      to: '/politica-de-privacidade',
    },
    {
      name: 'Termos de Serviço',
      to: '/termos-de-servico',
    },
  ]

  if (!window.isInfluenceriOS && !window.isInfluencerAndroid) {
    footerLinks.push({
      name: 'App iPhone',
      to: 'https://apps.apple.com/us/app/viral-influenciador/id6495164838?l=pt-BR',
    }, {
      name: 'App Android',
      to: 'https://play.google.com/store/apps/details?id=br.com.viral.influenciador&hl=pt&gl=pt',
    })
  }

  panels = [
    {
      name: 'PanelViralLinkPreferences',
      position: 'right',
      component: 'PanelViralLinkPreferences',
    },
    {
      name: 'PanelViralLinkYouTubeLink',
      position: 'right',
      component: 'PanelViralLinkYouTubeLink',
    },
    {
      name: 'PanelViralLinkUrl',
      position: 'right',
      component: 'PanelViralLinkUrl',
    },
    {
      name: 'PanelViralLinkAppearance',
      position: 'right',
      component: 'PanelViralLinkAppearance',
    },
    {
      name: 'PanelViralLinkFeedPostLink',
      position: 'right',
      component: 'PanelViralLinkFeedPostLink',
    },
    {
      name: 'PanelViralLinkContactForm',
      position: 'right',
      component: 'PanelViralLinkContactForm',
    },
    {
      name: 'PanelMidiaKitPreferences',
      position: 'right',
      component: 'PanelMidiaKitPreferences',
    },
    {
      name: 'PanelMidiaKitAppearance',
      position: 'right',
      component: 'PanelMidiaKitAppearance',
    },
    {
      name: 'PanelInfluencerPartnershipFromCampaignOrigin',
      position: 'right',
      component: 'PanelInfluencerPartnershipFromCampaignOrigin',
    },
    {
      name: 'PanelInfluencerPartnershipFromInfluencerOrigin',
      position: 'right',
      component: 'PanelInfluencerPartnershipFromInfluencerOrigin',
    },
    {
      name: 'PanelInfluencerPartnershipFromViralLinkOrigin',
      position: 'right',
      component: 'PanelInfluencerPartnershipFromViralLinkOrigin',
    },
    {
      name: 'PanelCreateInfluencerPartnership',
      position: 'right',
      component: 'PanelCreateInfluencerPartnership',
    },
    {
      name: 'PanelConfigureWithdrawal',
      position: 'right',
      component: 'PanelConfigureWithdrawal',
    },
  ]

  const colors = {
    '--color-primary-50': '253 242 248',
    '--color-primary-100': '252 231 243',
    '--color-primary-200': '251 207 232',
    '--color-primary-300': '236 72 153',
    '--color-primary-400': '244 114 182',
    '--color-primary-500': '236 72 153',
    '--color-primary-600': '219 39 119',
    '--color-primary-700': '190 24 93',
    '--color-primary-800': '157 23 77',
    '--color-primary-900': '131 24 67',
    '--color-primary-950': '80 7 36',
  }

  const root = document.documentElement
  for (const [key, value] of Object.entries(colors)) {
    root.style.setProperty(key, value)
  }
}

export default defineAppConfig({
  nui: {
    BaseInput: {
      rounded: 'sm',
    },
    BaseInputNumber: {
      rounded: 'sm',
    },
    BaseCard: {
      rounded: 'lg',
    },
    BaseButton: {
      rounded: 'md',
    },
    BaseTag: {
      rounded: 'md',
    },
    BaseButtonIcon: {
      rounded: 'full',
    },
    BaseButtonClose: {
      size: 'sm',
    },
    BasePagination: {
      rounded: 'lg',
    },
    BaseSelect: {
      rounded: 'sm',
    },
    BaseListbox: {
      rounded: 'sm',
    },
    BaseCheckbox: {
      rounded: 'sm',
    },
    BasePlaceload: {
      rounded: 'lg',
    },
  },
  tairo: {
    title: 'Viral.com.br',
    error: {
      logo: {
        component: 'LogoViral',
      },
    },
    iconnav: {
      circularMenu: {
        enabled: false,
        tools: [],
      },
      toolbar: {
        enabled: true,
        showTitle: false,
        tools: toolbarTools,
      },
      navigation: {
        enabled: true,
        logo: {
          component: 'LogoViral',
          props: {
            class: 'h-7 text-primary-500',
          },
        },
        items: navigationItems,
      },
      footer: {
        enabled: true,
        logoSeparator: {
          component: '',
        },
        logo: {
          component: 'LogoViral',
          props: {
            class: 'text-muted-300 ltablet:mx-0 mx-auto h-4 transition-all duration-200 lg:mx-0',
          },
        },
        copyright: {
          name: 'Viral',
          to: '/',
        },
        links: footerLinks,
      },
    },
    panels: panels,
  },
})
